<template>
  <div class="help-root">
    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">phone_in_talk</span>
      <p>
        Administra los medios de comunicación de la persona: registro,
        edición y consulta de teléfonos, correos y otros canales de contacto.
      </p>
    </div>
    <!-- Datos de la persona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">person</span>
        Datos de la persona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in datosPersona" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- Columnas de la tabla -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">table_rows</span>
        Columnas de la tabla
      </h3>
      <div class="help-estados">
        <span
          v-for="c in columnas"
          :key="c"
          class="help-estado-badge"
          style="background:#e2e3e5;color:#383d41"
        >{{ c }}</span>
      </div>
    </section>
    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>
    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>Mantener actualizados los medios de comunicación facilita la notificación oportuna de citas y resultados al paciente.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "AyudaMedioPersForm",
  data() {
    return {
      datosPersona: [
        { icon: "badge",       titulo: "Documento", desc: "Identificación de la persona consultada, mostrada como referencia en la parte superior." },
        { icon: "person",      titulo: "Nombre",    desc: "Nombre completo de la persona a la que pertenecen los medios de comunicación registrados." },
        { icon: "call",        titulo: "Teléfono",  desc: "Número telefónico principal registrado en los datos básicos de la persona." },
        { icon: "mail",        titulo: "Email",     desc: "Correo electrónico principal registrado en los datos básicos de la persona." },
      ],
      columnas: [
        "Id", "Persona", "Medio de Com.", "Descripción", "Fecha Reg.", "Estado",
      ],
      acciones: [
        { icon: "add_box",        color: "#198754", titulo: "Nuevo registro",  desc: "Pulsa el botón Nuevo para abrir el formulario y registrar un nuevo medio de comunicación." },
        { icon: "edit",           color: "#fd7e14", titulo: "Editar",          desc: "Haz clic en el ícono de edición de la fila para modificar los datos del medio de comunicación." },
        { icon: "delete",         color: "#dc3545", titulo: "Eliminar",        desc: "Haz clic en el ícono de eliminar para borrar el registro seleccionado." },
        { icon: "manage_search",  color: "#0059cc", titulo: "Buscar medio",    desc: "Usa la lupa junto al campo Medio Com. para seleccionar el tipo de medio de comunicación." },
        { icon: "download",       color: "#198754", titulo: "Exportar Excel",  desc: "Descarga el listado completo de medios de comunicación en un archivo Excel." },
      ],
    };
  },
};
</script>
<style src="@/assets/css/ayuda.css" scoped></style>